/*eslint-disable no-undef*/

import { httpClientIntegration } from '@sentry/integrations';
import { BrowserTracing, init as SentryInit, createReduxEnhancer } from '@sentry/react';

export default class SentryUtility {
  static init() {
    SentryInit({
      dsn: import.meta.env.VITE_SENTRY_DSN_KEY,
      environment: SentryUtility.getEnvironment(),
      tracesSampleRate: 0.5,
      normalizeDepth: 5,
      maxBreadcrumbs: 25,
      integrations: [
        new BrowserTracing(),
        httpClientIntegration({
          failedRequestStatusCodes: [400, 500]
        })
      ]
    });
  }

  static isLocalhost(url?: string) {
    url = url || window.location.origin;
    return url.includes('localhost') || url.includes('127.0.0.1');
  }

  static isStaging(url: string) {
    url = url || window.location.origin;
    return url.includes('staging.omniful.com');
  }

  static isProduction(url: string) {
    url = url || window.location.origin;
    return url.includes('beta.omniful.com');
  }

  static getEnvironment() {
    const basePath = window.location.origin;
    return (SentryUtility.isProduction(basePath) && 'Production')
      || (SentryUtility.isStaging(basePath) && 'Staging')
      || (SentryUtility.isLocalhost(basePath) && 'Development')
      || 'Development';
  }

  static logger = (data: unknown) => {
    return data;
  };

  // TODO
  static sentryReduxEnhancer = createReduxEnhancer({});
}